import { render, staticRenderFns } from "./ModalUseKit.vue?vue&type=template&id=f5218d18"
import script from "./ModalUseKit.vue?vue&type=script&lang=js"
export * from "./ModalUseKit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5218d18')) {
      api.createRecord('f5218d18', component.options)
    } else {
      api.reload('f5218d18', component.options)
    }
    module.hot.accept("./ModalUseKit.vue?vue&type=template&id=f5218d18", function () {
      api.rerender('f5218d18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/js/components-wa/modals/ModalUseKit.vue"
export default component.exports